import { render, staticRenderFns } from "./SideVideoCard.vue?vue&type=template&id=6254ae8e&scoped=true"
import script from "./SideVideoCard.vue?vue&type=script&lang=js"
export * from "./SideVideoCard.vue?vue&type=script&lang=js"
import style0 from "./SideVideoCard.vue?vue&type=style&index=0&id=6254ae8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6254ae8e",
  null
  
)

export default component.exports